import { Component } from '@theme/component';

/**
 * Bumps the product's quantity selector up to the minimum order quantity
 * (MOQ) of whichever printing method is selected. Never lowers a quantity
 * the shopper already raised above the MOQ.
 *
 * @extends {Component}
 */
class ProductPrintingMethod extends Component {
  connectedCallback() {
    super.connectedCallback();
    const checked = this.querySelector('input[type="radio"]:checked');
    if (checked instanceof HTMLInputElement) this.#applyMoq(checked);
  }

  /**
   * @param {Event} event
   */
  handleMethodChange(event) {
    const target = event.target;
    if (!(target instanceof HTMLInputElement)) return;
    this.#applyMoq(target);
  }

  /**
   * @param {HTMLInputElement} input
   */
  #applyMoq(input) {
    const moq = Number(input.dataset.moq);
    if (!moq || Number.isNaN(moq)) return;

    const quantitySelector = document.querySelector('quantity-selector-component[ref="quantitySelector"]');
    if (!(quantitySelector instanceof HTMLElement)) return;

    if (customElements.get('quantity-selector-component')) {
      customElements.upgrade(quantitySelector);
    }

    if (typeof (/** @type {any} */ (quantitySelector).updateConstraints) !== 'function') return;

    const quantityInput = quantitySelector.querySelector('[ref="quantityInput"]');
    if (!(quantityInput instanceof HTMLInputElement)) return;

    const max = quantityInput.max || null;
    const step = quantityInput.step || '1';

    /** @type {any} */ (quantitySelector).updateConstraints(String(moq), max, step);
    /** @type {any} */ (quantitySelector).onQuantityChange();
  }
}

if (!customElements.get('product-printing-method-component')) {
  customElements.define('product-printing-method-component', ProductPrintingMethod);
}
